/**
 * Unified notification pipeline — delegates to sendNotification (server-backed).
 */
import { sendNotification } from './notificationService';

const listeners = new Set();

function notifyLocal(userId, event, result) {
  listeners.forEach((fn) => {
    try {
      fn({ userId, event, itemId: result?.itemId ?? null });
    } catch (_) {}
  });
}

export const notificationBus = {
  /**
   * @param {string} userId
   * @param {import('./notificationTypes').NotificationEvent} event
   */
  async emit(userId, event) {
    if (!userId || !event) return null;
    const result = await sendNotification({
      userId,
      type: event.type,
      title: event.title,
      body: event.body,
      data: event.meta || {},
      priority: event.priority || 'medium',
      dedupeKey: event.dedupeKey,
      group: event.group,
    });
    notifyLocal(userId, event, result);
    return result?.itemId ?? null;
  },

  /** @param {(payload: { userId: string, event: object, itemId: string|null }) => void} fn */
  subscribe(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
};

export { sendNotification };
